"use client";

import type { ReactNode } from "react";
import { useHover } from "react-aria";

export interface PricingCardLayoutProps {
  /** The card header section (use PricingCardHeader) */
  header: ReactNode;
  /** The CTA button section */
  cta?: ReactNode;
  /** Custom class name for the CTA wrapper. Defaults to "tw-mt-4 tw-mb-6". */
  ctaClassName?: string;
  /** The features list section */
  features?: ReactNode;
  /** Optional footer content (e.g., credits included) */
  footer?: ReactNode;
  /** Callback when hover starts on this card */
  onHoverStart?: () => void;
}

/**
 * Shared layout component for pricing and model cards.
 * Provides consistent structure with flexible slots for each section.
 */
export const PricingCardLayout = ({
  header,
  cta,
  ctaClassName = "tw-mt-4 tw-mb-6",
  features,
  footer,
  onHoverStart,
}: PricingCardLayoutProps) => {
  const { hoverProps } = useHover({
    onHoverStart: () => onHoverStart?.(),
  });

  return (
    <div {...hoverProps} className='tw-relative tw-flex tw-flex-col tw-h-full'>
      {/* Card Header */}
      {header}

      {/* CTA Button */}
      {cta && <div className={ctaClassName}>{cta}</div>}

      {/* Features List */}
      {features && <div className='tw-flex-1'>{features}</div>}

      {/* Footer */}
      {footer}
    </div>
  );
};
